export default __webpack_public_path__ + "static/media/mapStat1LegendM.48981588.svg";